import React from 'react';
import cn from 'bem-cn';

// import { copyToClipboard } from '../../utils/clipboard/clipboard';
import { useGetUserScoreQuery } from '../../store/services/leaderboard';
import { AvatarWithRating, Stack } from '../../components/UI';

import { ProfileProps } from './Profile.types';

import './Profile.scss';

const b = cn('profile');

export const Profile: React.FC<ProfileProps> = ({
    avatarSrc = '',
    firstName = '',
    lastName = '',
    // uid = '',
}) => {
    const { data: scoreData, isError: scoreIsError, isLoading: isScoreLoading } = useGetUserScoreQuery();

    // const handleShareClick = () => {
    //     copyToClipboard(`${window.location.hostname}/prompthub/users/${id}`);
    // };

    return (
        <Stack spacing={16} className={b()} alignItems="center">
            <AvatarWithRating
                size="large"
                avatarSrc={avatarSrc}
                score={scoreData?.score}
                isScoreLoading={isScoreLoading}
                scoreError={scoreIsError || scoreData?.is_user_exists === false}
            />
            <Stack spacing={8}>
                <Stack spacing={8} direction="row" alignItems="center" justifyContent="center">
                    <span className={b('name')}>
                        {firstName} {lastName?.at(0)}.
                    </span>
                    {/* <Popover position="top" content="Ссылка скопирована">
                        <Icon
                            name="share"
                            size={20}
                            fillColor="rgba(0, 0, 0, 0.9)"
                            className={b('share')}
                            onClick={handleShareClick}
                        />
                    </Popover> */}
                </Stack>
                {/* <Stack
                    spacing={6}
                    direction="row"
                    alignItems="center"
                    justifyContent="center"
                    className={b('toLeaderboard')}
                >
                    <span>В рейтинге:</span>
                    <Icon name="trophy" size={20} fillColor="rgba(0, 0, 0, 0.6)" className="trophy" />
                    <span>{place}</span>
                    <Icon name="chevron_right" size={16} strokeColor="rgba(0, 0, 0, 0.6)" className="chevron-right" />
                </Stack> */}
            </Stack>
        </Stack>
    );
};
